module.exports = __webpack_public_path__ + "static/media/gb-wls.acae1774.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb-wls.svg
// module id = 121
// module chunks = 0